import React from 'react'

import {
  useInRouterContext,
  useLocation,
  useNavigate,
  useParams,
} from 'react-router-dom'

const withRouter = (Component) => {
  return function ComponentWithRouter(props) {
    const location = useLocation()
    const navigate = useNavigate()
    const params = useParams()
    return <Component {...props} router={{ location, navigate, params }} />
  }
}

const withCheckIsRouter = (Component) => {
  return function ComponentWithCheckIsRouter(props) {
    const isRouter = useInRouterContext()
    if (isRouter) {
      return withRouter(Component)(props)
    }
    return <Component {...props} />
  }
}

export default withCheckIsRouter
